module.exports = __webpack_public_path__ + "static/media/screen.27eb51c2.png";